<template>
  <div class="l-container FamiliesAdd">
    <p class="m-label">AP選択</p>
    <table-c>
      <tr-c slot="tr-th">
        <!-- <td&#45;c><input v&#45;model="search.id" type="text" @keyup="searchTable()" placeholder="検索"></td&#45;c> -->
        <!-- <td&#45;c><input v&#45;model="search.family_id" type="text" @keyup="searchTable()"></td&#45;c> -->
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.state" :options="state" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c><input v-model="search.name" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.kana" type="text" @keyup="searchTable()"></td-c>
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.pref" :options="prefs" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c><input v-model="search.address" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.tel1" type="text" @keyup="searchTable()" v-focus></td-c>
        <td-c><input v-model="search.tel2" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.contact_date" type="text" @keyup="searchTable()"></td-c>
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.support" :options="support" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c><input v-model="search.acquisition_date[0]" type="text" @keyup="searchTable()"></td-c>
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.medium1" :options="medium" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.medium2" :options="medium" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.medium3" :options="medium" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <!-- <td&#45;c class="select"> -->
        <!--   <multiselect @select="select, searchTable()" v&#45;model="watchSearch.gender" :options="gender" label="name" placeholder="" :show&#45;labels="false"></multiselect> -->
        <!-- </td&#45;c> -->
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.school_stage" :options="school_stage" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.grade" :options="grade" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c><input v-model="search.visit_date" type="text" @keyup="searchTable()"></td-c>
      </tr-c>

      <tr-c slot="tr-th">
        <!-- <td&#45;c><input v&#45;model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外"></td&#45;c> -->
        <!-- <td&#45;c><input v&#45;model="search.not_family_id" type="text" @keyup="searchTable()"></td&#45;c> -->
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.not_state" :options="state" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c><input v-model="search.not_name" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.not_kana" type="text" @keyup="searchTable()"></td-c>
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.not_pref" :options="prefs" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c><input v-model="search.not_address" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.not_tel1" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.not_tel2" type="text" @keyup="searchTable()"></td-c>
        <td-c><input v-model="search.not_contact_date" type="text" @keyup="searchTable()"></td-c>
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.not_support" :options="support" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c><input v-model="search.not_acquisition_date[0]" type="text" @keyup="searchTable()"></td-c>
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.not_medium1" :options="medium" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.not_medium2" :options="medium" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.not_medium3" :options="medium" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <!-- <td&#45;c class="select"> -->
        <!--   <multiselect @select="select, searchTable()" v&#45;model="watchSearch.not_gender" :options="gender" label="name" placeholder="" :show&#45;labels="false"></multiselect> -->
        <!-- </td&#45;c> -->
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.not_school_stage" :options="school_stage" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c class="select">
          <multiselect @select="select, searchTable()" v-model="watchSearch.not_grade" :options="grade" label="name" placeholder="" :show-labels="false"></multiselect>
        </td-c>
        <td-c><input v-model="search.not_visit_date" type="text" @keyup="searchTable()"></td-c>
      </tr-c>

      <tr-c slot="tr-th">
        <!-- <th&#45;c @click.native='sort("id")'>ID</th&#45;c> -->
        <!-- <th&#45;c @click.native='sort("family_id")'>家庭ID</th&#45;c> -->
        <th-c @click.native='sort("state")'>状態</th-c>
        <th-c @click.native='sort("name")'>名前</th-c>
        <th-c @click.native='sort("kana")'>かな</th-c>
        <th-c @click.native='sort("pref")'>都道府県</th-c>
        <th-c @click.native='sort("address1 + address2")'>住所</th-c>
        <th-c @click.native='sort("tel1")'>携帯TEL</th-c>
        <th-c @click.native='sort("tel2")'>固定TEL</th-c>
        <th-c @click.native='sort("contact_date")'>問い合わせ日</th-c>
        <th-c @click.native='sort("support")'>問合せ結果</th-c>
        <th-c @click.native='sort("acquisition_date")'>取得日</th-c>
        <th-c @click.native='sort("medium1")'>媒体1</th-c>
        <th-c @click.native='sort("medium2")'>媒体2</th-c>
        <th-c @click.native='sort("medium3")'>媒体3</th-c>
        <!-- <th&#45;c @click.native='sort("gender")'>性別</th&#45;c> -->
        <th-c @click.native='sort("school_stage")'>小学/中学/高校</th-c>
        <th-c @click.native='sort("grade")'>学年</th-c>
        <th-c @click.native='sort("visit_date")'>訪問日時</th-c>
      </tr-c>

      <tr-c slot="tr-td" @click.native="[getData(list), input(list)]" v-for="list in filteredAppointments" :key="list.id">
        <template v-if="clickedId.indexOf(list.id) !== -1">
          <!-- <td&#45;c class="clicked">{{list.id}}</td&#45;c> -->
          <!-- <td&#45;c class="clicked">{{list.family_id}}</td&#45;c> -->
          <template>
            <td-c class="clicked" v-if="list.state === 0">未選択</td-c>
            <td-c class="clicked" v-if="list.state === 1">新規</td-c>
            <td-c class="clicked" v-if="list.state === 2">保留上げ</td-c>
            <td-c class="clicked" v-if="list.state === 3">書換</td-c>
            <td-c class="clicked" v-if="list.state === 4">内容変更</td-c>
            <td-c class="clicked" v-if="list.state === 5">引継</td-c>
          </template>
          <td-c class="clicked">{{list.f_name}} {{list.l_name}}</td-c>
          <td-c class="clicked">{{list.f_name_kana}} {{list.l_name_kana}}</td-c>
          <td-c class="clicked">{{list.mapPref}}</td-c>
          <td-c class="clicked">{{list.address1}}{{list.address2}}</td-c>
          <td-c class="clicked">{{list.tel1}}</td-c>
          <td-c class="clicked">{{list.tel2}}</td-c>
          <td-c class="clicked">{{list.contact_date}}</td-c>
          <template>
            <td-c class="clicked" v-if="list.support === 0">未選択</td-c>
            <td-c class="clicked" v-if="list.support === 1">獲得</td-c>
            <td-c class="clicked" v-if="list.support === 2">逃し</td-c>
            <td-c class="clicked" v-if="list.support === 3">断り</td-c>
            <td-c class="clicked" v-if="list.support === 4">APCXL</td-c>
            <td-c class="clicked" v-if="list.support === 5">ツブレ</td-c>
          </template>
          <td-c class="clicked">{{list.acquisition_date}}</td-c>
          <template>
            <td-c class="clicked" v-if="list.medium1 === 0">未選択</td-c>
            <td-c class="clicked" v-if="list.medium1 === 1">DM</td-c>
            <td-c class="clicked" v-if="list.medium1 === 2">貼紙</td-c>
            <td-c class="clicked" v-if="list.medium1 === 3">HP</td-c>
            <td-c class="clicked" v-if="list.medium1 === 4">紹介</td-c>
            <td-c class="clicked" v-if="list.medium1 === 5">TEL注</td-c>
            <td-c class="clicked" v-if="list.medium1 === 6">TA</td-c>
            <td-c class="clicked" v-if="list.medium1 === 7">その他</td-c>
          </template>
          <template>
            <td-c class="clicked" v-if="list.medium2 === 0">未選択</td-c>
            <td-c class="clicked" v-if="list.medium2 === 1">DM</td-c>
            <td-c class="clicked" v-if="list.medium2 === 2">貼紙</td-c>
            <td-c class="clicked" v-if="list.medium2 === 3">HP</td-c>
            <td-c class="clicked" v-if="list.medium2 === 4">紹介</td-c>
            <td-c class="clicked" v-if="list.medium2 === 5">TEL注</td-c>
            <td-c class="clicked" v-if="list.medium2 === 6">TA</td-c>
            <td-c class="clicked" v-if="list.medium2 === 7">その他</td-c>
          </template>
          <template>
            <td-c class="clicked" v-if="list.medium3 === 0">未選択</td-c>
            <td-c class="clicked" v-if="list.medium3 === 1">DM</td-c>
            <td-c class="clicked" v-if="list.medium3 === 2">貼紙</td-c>
            <td-c class="clicked" v-if="list.medium3 === 3">HP</td-c>
            <td-c class="clicked" v-if="list.medium3 === 4">紹介</td-c>
            <td-c class="clicked" v-if="list.medium3 === 5">TEL注</td-c>
            <td-c class="clicked" v-if="list.medium3 === 6">TA</td-c>
            <td-c class="clicked" v-if="list.medium3 === 7">その他</td-c>
          </template>
          <!-- <template> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.gender === 0">未選択</td&#45;c> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.gender === 1">男</td&#45;c> -->
          <!--   <td&#45;c class="clicked" v&#45;if="list.gender === 2">女</td&#45;c> -->
          <!-- </template> -->
          <template>
            <td-c class="clicked" v-if="list.school_stage === 0">未選択</td-c>
            <td-c class="clicked" v-if="list.school_stage === 1">小学</td-c>
            <td-c class="clicked" v-if="list.school_stage === 2">中学</td-c>
            <td-c class="clicked" v-if="list.school_stage === 3">高校</td-c>
            <td-c class="clicked" v-if="list.school_stage === 4">幼稚園</td-c>
            <td-c class="clicked" v-if="list.school_stage === 5">その他</td-c>
          </template>
          <template>
            <td-c class="clicked" v-if="list.grade === 0">未選択</td-c>
            <td-c class="clicked" v-if="list.grade === 1">1</td-c>
            <td-c class="clicked" v-if="list.grade === 2">2</td-c>
            <td-c class="clicked" v-if="list.grade === 3">3</td-c>
            <td-c class="clicked" v-if="list.grade === 4">4</td-c>
            <td-c class="clicked" v-if="list.grade === 5">5</td-c>
            <td-c class="clicked" v-if="list.grade === 6">6</td-c>
          </template>
          <td-c class="clicked">{{list.visit_date}}</td-c>
        </template>

        <template v-if="clickedId.indexOf(list.id) === -1">
          <!-- <td&#45;c>{{list.id}}</td&#45;c> -->
          <!-- <td&#45;c>{{list.family_id}}</td&#45;c> -->
          <template>
            <td-c v-if="list.state === 0">未選択</td-c>
            <td-c v-if="list.state === 1">新規</td-c>
            <td-c v-if="list.state === 2">保留上げ</td-c>
            <td-c v-if="list.state === 3">書換</td-c>
            <td-c v-if="list.state === 4">内容変更</td-c>
            <td-c v-if="list.state === 5">引継</td-c>
          </template>
          <td-c>{{list.f_name}} {{list.l_name}}</td-c>
          <td-c>{{list.f_name_kana}} {{list.l_name_kana}}</td-c>
          <td-c>{{list.mapPref}}</td-c>
          <td-c>{{list.address1}}{{list.address2}}</td-c>
          <td-c>{{list.tel1}}</td-c>
          <td-c>{{list.tel2}}</td-c>
          <td-c>{{list.contact_date}}</td-c>
          <template>
            <td-c v-if="list.support === 0">未選択</td-c>
            <td-c v-if="list.support === 1">獲得</td-c>
            <td-c v-if="list.support === 2">逃し</td-c>
            <td-c v-if="list.support === 3">断り</td-c>
            <td-c v-if="list.support === 4">APCXL</td-c>
            <td-c v-if="list.support === 5">ツブレ</td-c>
          </template>
          <td-c>{{list.acquisition_date}}</td-c>
          <template>
            <td-c v-if="list.medium1 === 0">未選択</td-c>
            <td-c v-if="list.medium1 === 1">DM</td-c>
            <td-c v-if="list.medium1 === 2">貼紙</td-c>
            <td-c v-if="list.medium1 === 3">HP</td-c>
            <td-c v-if="list.medium1 === 4">紹介</td-c>
            <td-c v-if="list.medium1 === 5">TEL注</td-c>
            <td-c v-if="list.medium1 === 6">TA</td-c>
            <td-c v-if="list.medium1 === 7">その他</td-c>
          </template>
          <template>
            <td-c v-if="list.medium2 === 0">未選択</td-c>
            <td-c v-if="list.medium2 === 1">DM</td-c>
            <td-c v-if="list.medium2 === 2">貼紙</td-c>
            <td-c v-if="list.medium2 === 3">HP</td-c>
            <td-c v-if="list.medium2 === 4">紹介</td-c>
            <td-c v-if="list.medium2 === 5">TEL注</td-c>
            <td-c v-if="list.medium2 === 6">TA</td-c>
            <td-c v-if="list.medium2 === 7">その他</td-c>
          </template>
          <template>
            <td-c v-if="list.medium3 === 0">未選択</td-c>
            <td-c v-if="list.medium3 === 1">DM</td-c>
            <td-c v-if="list.medium3 === 2">貼紙</td-c>
            <td-c v-if="list.medium3 === 3">HP</td-c>
            <td-c v-if="list.medium3 === 4">紹介</td-c>
            <td-c v-if="list.medium3 === 5">TEL注</td-c>
            <td-c v-if="list.medium3 === 6">TA</td-c>
            <td-c v-if="list.medium3 === 7">その他</td-c>
          </template>
          <!-- <template> -->
          <!--   <td&#45;c v&#45;if="list.gender === 0">未選択</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.gender === 1">男</td&#45;c> -->
          <!--   <td&#45;c v&#45;if="list.gender === 2">女</td&#45;c> -->
          <!-- </template> -->
          <template>
            <td-c v-if="list.school_stage === 0">未選択</td-c>
            <td-c v-if="list.school_stage === 1">小学</td-c>
            <td-c v-if="list.school_stage === 2">中学</td-c>
            <td-c v-if="list.school_stage === 3">高校</td-c>
            <td-c v-if="list.school_stage === 4">幼稚園</td-c>
            <td-c v-if="list.school_stage === 5">その他</td-c>
          </template>
          <template>
            <td-c v-if="list.grade === 0">未選択</td-c>
            <td-c v-if="list.grade === 1">1</td-c>
            <td-c v-if="list.grade === 2">2</td-c>
            <td-c v-if="list.grade === 3">3</td-c>
            <td-c v-if="list.grade === 4">4</td-c>
            <td-c v-if="list.grade === 5">5</td-c>
            <td-c v-if="list.grade === 6">6</td-c>
          </template>
          <td-c>{{list.visit_date}}</td-c>
        </template>
      </tr-c>
    </table-c>

    <p class="m-label">
      新規追加
      <span class="errors">
        <span v-if="!valid"> {{errors}} が入力されていません</span>
        <span v-if="valid"></span>
      </span>
    </p>

    <btn @click.native="reset">Reset</btn>

    <form class="h-adr" @submit.prevent="postFamily">
      <div class="form-wrapper">
        <family-form :family="family" :watch="watchFamily"></family-form>
      </div>

      <button type="submit" class="u-btn"><i class="fa fa-user-plus"></i>家庭情報を新規追加</button>
    </form>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/appointments/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  pageName: 'appointment',
  pageNames: 'appointments'
}

let _ = window._
export default {
  directives: {
    focus: {
      inserted: function (el, binding) {
        el.focus()
      }
    }
  },
  data () {
    return {
      asc: '',
      desc: '',
      sortState: 'desc',

      appointment: [],

      family: {
        f_name: '',
        l_name: '',
        f_name_kana: '',
        l_name_kana: '',
        relationship: 0,
        zip: '',
        pref: 0,
        geometry: '',
        address1: '',
        address2: '',
        tel1: '',
        tel2: '',
        fax: '',
        mail: '',
        mail2: '',
        guidance_type: 0,
        structure: '',
        unit: 0,
        workplace_contact: '',
        preferred_contact: 0,
        contact_timezone: '',
        withdrawal_date: '0001/01/01',
        note1: '',
        note2: ''
      },

      watchFamily: {
        relationship: '',
        pref: '',
        guidance_type: '',
        unit: '',
        preferred_contact: ''
      },

      search: {
        id: '',
        family_id: '',
        user_id: '',
        state: '',
        name: '',
        kana: '',
        pref: '',
        address: '',
        tel1: '',
        tel2: '',
        contact_date: '',
        support: '',
        acquisition_date: [],
        medium1: '',
        medium2: '',
        medium3: '',
        gender: '',
        school_type: '',
        school_stage: '',
        grade: '',
        memo: '',
        dm: '',
        shop_type: '',
        shop_name: '',
        hp_browse: '',
        visit_date: '',
        note: '',
        created_at: '',

        not_id: '',
        not_family_id: '',
        not_user_id: '',
        not_state: '',
        not_name: '',
        not_kana: '',
        not_pref: '',
        not_address: '',
        not_tel1: '',
        not_tel2: '',
        not_contact_date: '',
        not_support: '',
        not_acquisition_date: [],
        not_medium1: '',
        not_medium2: '',
        not_medium3: '',
        not_gender: '',
        not_school_type: '',
        not_school_stage: '',
        not_grade: '',
        not_memo: '',
        not_dm: '',
        not_shop_type: '',
        not_shop_name: '',
        not_hp_browse: '',
        not_visit_date: '',
        not_note: '',
        not_created_at: ''
      },

      watchSearch: {
        state: '',
        pref: '',
        support: '',
        medium1: '',
        medium2: '',
        medium3: '',
        shop_type: '',
        hp_browse: '',
        gender: '',
        school_type: '',
        school_stage: '',
        grade: '',

        not_state: '',
        not_pref: '',
        not_support: '',
        not_medium1: '',
        not_medium2: '',
        not_medium3: '',
        not_shop_type: '',
        not_hp_browse: '',
        not_gender: '',
        not_school_type: '',
        not_school_stage: '',
        not_grade: ''
      }
    }
  },
  computed: {
    state () {
      return this.$store.getters['appointments/state']
    },

    support () {
      return this.$store.getters['appointments/support']
    },

    medium () {
      return this.$store.getters['appointments/medium']
    },

    hp_browse () {
      return this.$store.getters['appointments/hp_browse']
    },

    gender () {
      return this.$store.getters['appointments/gender']
    },

    school_type () {
      return this.$store.getters['appointments/school_type']
    },

    school_stage () {
      return this.$store.getters['appointments/school_stage']
    },

    grade () {
      return this.$store.getters['appointments/grade']
    },

    user () {
      return this.$store.getters.user
    },

    appointments () {
      return this.$store.getters.appointments
    },

    prefs () {
      return this.$store.getters.prefs
    },

    clickedId () {
      var arr = []
      for (var i = 0; this.appointment.length > i; i++) {
        arr.push(this.appointment[i].id)
      }
      return arr
    },

    orderedAppointments () {
      if (this.sortState === '' || this.sortState === 'asc') {
        return _.orderBy(this.appointments, this.asc)
      } else if (this.sortState === 'desc') {
        return _.orderBy(this.appointments, this.desc).reverse()
      }
    },

    filteredAppointments () {
      return this.orderedAppointments.filter(appointment => {
        appointment.mapPref = this.calcPref(appointment.pref)
        return appointment
      })
    },

    // validation
    appointmentErrors () {
      return this.appointment.length > 0 ? [] : ['AP選択']
    },

    f_name_kanaErrors () {
      return this.family.f_name_kana ? [] : ['せい']
    },

    l_name_kanaErrors () {
      return this.family.l_name_kana ? [] : ['めい']
    },

    prefErrors () {
      return this.family.pref ? [] : ['都道府県']
    },

    address1Errors () {
      return this.family.address1 ? [] : ['住所(市区町村・番地)']
    },

    tel1Errors () {
      return this.family.tel1 ? [] : ['携帯TEL']
    },

    withdrawal_dateErrors () {
      return this.family.withdrawal_date ? [] : ['退会日']
    },

    errors: function () {
      let errors = [].concat(
        this.appointmentErrors,
        this.f_name_kanaErrors,
        this.l_name_kanaErrors,
        this.prefErrors,
        this.address1Errors,
        this.tel1Errors,
        this.withdrawal_dateErrors
      )
      let errorsJoin = errors.join('・')
      return errorsJoin
    },
    valid: function () {
      return !this.errors
    }
  },
  watch: {
    'watchFamily.relationship': function (now, old) {
      if (now) {
        this.family.relationship = now.value
      }
    },

    'watchFamily.pref': function (now, old) {
      if (now) {
        this.family.pref = now.id
        this.family.geometry = now.name
      }
    },

    'watchFamily.guidance_type': function (now, old) {
      if (now) {
        this.family.guidance_type = now.value
      }
    },

    'watchFamily.unit': function (now, old) {
      if (now) {
        this.family.unit = now.value
      }
    },

    'watchFamily.preferred_contact': function (now, old) {
      if (now) {
        this.family.preferred_contact = now.value
      }
    },

    'watchSearch.state': function (now, old) {
      if (now) {
        this.search.state = now.value
      }
    },

    'watchSearch.pref': function (now, old) {
      if (now) {
        this.search.pref = now.id
      }
    },

    'watchSearch.support': function (now, old) {
      if (now) {
        this.search.support = now.value
      }
    },

    'watchSearch.medium1': function (now, old) {
      if (now) {
        this.search.medium1 = now.value
      }
    },

    'watchSearch.medium2': function (now, old) {
      if (now) {
        this.search.medium2 = now.value
      }
    },

    'watchSearch.medium3': function (now, old) {
      if (now) {
        this.search.medium3 = now.value
      }
    },

    'watchSearch.shop_type': function (now, old) {
      if (now) {
        this.search.shop_type = now.value
      }
    },

    'watchSearch.hp_browse': function (now, old) {
      if (now) {
        this.search.hp_browse = now.value
      }
    },

    'watchSearch.gender': function (now, old) {
      if (now) {
        this.search.gender = now.value
      }
    },

    'watchSearch.school_type': function (now, old) {
      if (now) {
        this.search.school_type = now.value
      }
    },

    'watchSearch.school_stage': function (now, old) {
      if (now) {
        this.search.school_stage = now.value
      }
    },

    'watchSearch.grade': function (now, old) {
      if (now) {
        this.search.grade = now.value
      }
    },

    'watchSearch.not_state': function (now, old) {
      if (now) {
        this.search.not_state = now.value
      }
    },

    'watchSearch.not_pref': function (now, old) {
      if (now) {
        this.search.not_pref = now.id
      }
    },

    'watchSearch.not_support': function (now, old) {
      if (now) {
        this.search.not_support = now.value
      }
    },

    'watchSearch.not_medium1': function (now, old) {
      if (now) {
        this.search.not_medium1 = now.value
      }
    },

    'watchSearch.not_medium2': function (now, old) {
      if (now) {
        this.search.not_medium2 = now.value
      }
    },

    'watchSearch.not_medium3': function (now, old) {
      if (now) {
        this.search.not_medium3 = now.value
      }
    },

    'watchSearch.not_shop_type': function (now, old) {
      if (now) {
        this.search.not_shop_type = now.value
      }
    },

    'watchSearch.not_hp_browse': function (now, old) {
      if (now) {
        this.search.not_hp_browse = now.value
      }
    },

    'watchSearch.not_gender': function (now, old) {
      if (now) {
        this.search.not_gender = now.value
      }
    },

    'watchSearch.not_school_type': function (now, old) {
      if (now) {
        this.search.not_school_type = now.value
      }
    },

    'watchSearch.not_school_stage': function (now, old) {
      if (now) {
        this.search.not_school_stage = now.value
      }
    },

    'watchSearch.not_grade': function (now, old) {
      if (now) {
        this.search.not_grade = now.value
      }
    }
  },
  methods: {
    calcPref (pref_id) {
      if (pref_id) {
        return this.prefs.filter(pref => {
          return pref.id === pref_id
        })[0].name
      } else {
        return
      }
    },

    select (selectedOption, id) {
      // console.log(selectedOption)
      // console.log(this.searchType)
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === 'desc') {
        this.sortState = 'asc'
        this.asc = header
      } else if (this.sortState === 'asc') {
        this.sortState = 'desc'
        this.desc = header
      }
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    getData (appointment) {
      // find.index
      var index = this.appointment.findIndex((x) => {
        return (x.id === appointment.id)
      })
      if (index === -1) {
        console.log('nai')
        this.appointment.push(appointment)
      } else {
        console.log('aru')
        this.appointment.splice(index, 1)
      }
    },

    input (appointment) {
      this.family.f_name = appointment.f_name
      this.family.f_name_kana = appointment.f_name_kana
      this.family.tel1 = appointment.tel1
      this.family.tel2 = appointment.tel2
      this.family.zip = appointment.zip
      this.watchFamily.pref = this.prefs.filter(pref => {
        return pref.id === appointment.pref
      })[0]
      this.family.address1 = appointment.address1
      this.family.address2 = appointment.address2
      this.family.mail = appointment.mail
      this.family.mail2 = appointment.mail2
    },

    postFamily () {
      if (this.appointment.length > 0) {
        this.$store.dispatch('postFamily', {
          this: this,
          family: this.family,
          appointment: this.appointment,
          watchFamily: this.watchFamily,
          reset: this.reset
        })
        this.save()
      } else {
        alert('紐づけるAPを選択して下さい。')
      }
    },

    save () {
      // alert('save')
      let arr = []
      let obj = {

        f_name: this.family.f_name,
        l_name: this.family.l_name,
        f_name_kana: this.family.f_name_kana,
        l_name_kana: this.family.l_name_kana,
        relationship: this.watchFamily.relationship,
        zip: this.family.zip,
        pref: this.watchFamily.pref,
        address1: this.family.address1,
        address2: this.family.address2,
        tel1: this.family.tel1,
        tel2: this.family.tel2,
        fax: this.family.fax,
        mail: this.family.mail,
        mail2: this.family.mail2,
        guidance_type: this.watchFamily.guidance_type,
        structure: this.family.structure,
        unit: this.watchFamily.unit,
        workplace_contact: this.family.workplace_contact,
        preferred_contact: this.watchFamily.preferred_contact,
        contact_timezone: this.family.contact_timezone,
        withdrawal_date: this.family.withdrawal_date,
        note1: this.family.note1,
        note2: this.family.note2
      }
      arr.push(obj)
      let setjson = JSON.stringify(obj)
      localStorage.setItem('FamiliesAdd', setjson)
    },

    get () {
      // alert('get')
      let getjson = localStorage.getItem('FamiliesAdd')
      let obj = JSON.parse(getjson)

      this.family.f_name = obj['f_name']
      this.family.l_name = obj['l_name']
      this.family.f_name_kana = obj['f_name_kana']
      this.family.l_name_kana = obj['l_name_kana']
      this.watchFamily.relationship = obj['relationship']
      this.family.zip = obj['zip']
      this.watchFamily.pref = obj['pref']
      this.family.address1 = obj['address1']
      this.family.address2 = obj['address2']
      this.family.tel1 = obj['tel1']
      this.family.tel2 = obj['tel2']
      this.family.fax = obj['fax']
      this.family.mail = obj['mail']
      this.family.mail2 = obj['mail2']
      this.watchFamily.guidance_type = obj['guidance_type']
      this.family.structure = obj['structure']
      this.watchFamily.unit = obj['unit']
      this.family.workplace_contact = obj['workplace_contact']
      this.watchFamily.preferred_contact = obj['preferred_contact']
      this.family.contact_timezone = obj['contact_timezone']
      this.family.withdrawal_date = obj['withdrawal_date']
      this.family.note1 = obj['note1']
      this.family.note2 = obj['note2']
      // console.log(obj)
    },

    reset () {
      this.family.f_name = ''
      this.family.l_name = ''
      this.family.f_name_kana = ''
      this.family.l_name_kana = ''
      this.watchFamily.relationship = 0
      this.family.zip = ''
      this.watchFamily.pref = 0
      this.family.address1 = ''
      this.family.address2 = ''
      this.family.tel1 = ''
      this.family.tel2 = ''
      this.family.fax = ''
      this.family.mail = ''
      this.family.mail2 = ''
      this.watchFamily.guidance_type = 0
      this.family.structure = ''
      this.watchFamily.unit = 0
      this.family.workplace_contact = ''
      this.watchFamily.preferred_contact = 0
      this.family.contact_timezone = ''
      this.family.withdrawal_date = '0001/01/01'
      this.family.note1 = ''
      this.family.note2 = ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.get()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.save()
    next()
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.form-wrapper {
  overflow: scroll;
  height: calc(100vh - 400px);
}
.errors {
  color: red;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
.fa-user-plus {
  margin-right: 5px;
}
.u-btn {
  margin-top: 1rem;
}
button {
  background-color: var(--color-point);
  color: #fff;
  margin-bottom: 13px;
  font-size:1rem;
  font-weight: bold;
  width: 100%;
  text-align: center;
  padding: 1em;
  border: 0;
  cursor: pointer;
  transition: opacity 0.5s ease-in-out;
  &:hover {
    opacity: .8;
  }
  &:focus {
    outline: 0;
  }
}
input {
  width: 100%;
  /* min-width: 100px; */
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.clicked {
  background: #41B883;
  font-weight: bold;
  color: #fff;
}
</style>
<style lang="scss">
.FamiliesAdd {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 1px;
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// FamiliesAdd.vue?1ca35638